import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import Spinner from 'components/Spinner';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';

import { sendAuthenticatedAsyncRequest } from '../../services/AsyncRequestService';
import { updateEmbedUrl } from "./Landing.actions";

const Landing = ({ isSourceSWIM, dashboardId }) => {
  const dispatch = useDispatch();
  const [dashboardUrlLoading, setDashboardUrlLoading] = useState(false);
  const [error, setError] = useState(null);
  const embeddedDashboardRef = useRef(null);
  const embeddingContextRef = useRef(null);

  useEffect(() => {
    let isMounted = true;
    let sendEmbeddedDashboardUrlRequest;

    const initializeQuicksightDashboard = async (embedUrl) => {
      const containerElement = document.getElementById("dashboardContainer");
      if (!containerElement) {
        setError("Dashboard container not found");
        return;
      }

      containerElement.innerHTML = '';

      try {
        // Dynamic import to avoid bundler issues
        const { createEmbeddingContext } = await import('amazon-quicksight-embedding-sdk');
        
        if (!embeddingContextRef.current) {
          embeddingContextRef.current = await createEmbeddingContext();
        }

        const options = {
          url: embedUrl,
          container: containerElement,
          width: "100%",
          height: "700px",
        };

        embeddedDashboardRef.current = await embeddingContextRef.current.embedDashboard(options);
        console.log("Dashboard embedded successfully");
      } catch (err) {
        console.error("QuickSight embedding error:", err);
        if (isMounted) {
          setError(`Failed to embed dashboard: ${err.message}`);
        }
      }
    };

    const onEmbedUrlFound = (response) => {
      if (!isMounted) return;
      setDashboardUrlLoading(false);
      setError(null);
      dispatch(updateEmbedUrl(response.data));
      initializeQuicksightDashboard(response.data);
    };

    const onEmbedUrlNotFound = (err) => {
      if (!isMounted) return;
      setDashboardUrlLoading(false);
      setError("Failed to fetch dashboard URL.");
    };

    sendEmbeddedDashboardUrlRequest = () => {
      const uri = isSourceSWIM === false
        ? dashboardId
          ? `/analytics/quicksight-dashboard-url/${dashboardId}`
          : "/agent-workspace/quicksight-dashboard-url"
        : "/swim/quicksight-dashboard-url";
      setDashboardUrlLoading(true);
      setError(null);
      sendAuthenticatedAsyncRequest(uri, "GET", null, onEmbedUrlFound, onEmbedUrlNotFound);
    };

    sendEmbeddedDashboardUrlRequest();

    return () => {
      isMounted = false;
    };
  }, [isSourceSWIM, dashboardId, dispatch]);

  return (
    <Container fluid className='top-spacer'>
      <Row>
        <Col md={12}>
          {dashboardUrlLoading && <Spinner />}
          {error && <Alert variant="danger">{error}</Alert>}
          <div id="dashboardContainer" style={{ minHeight: '700px' }}></div>
        </Col>
      </Row>
    </Container>
  );
};

export default Landing;